import { documentConstants } from "../../constants";
import { documentService } from "../../../services/api.documents";
import { notify } from "reapop";
import { OperationDocumentType } from "../../../helpers/enums";

export const paymentActions = {
  getAll,
  update,
  archive,
  changeViewStatus,
  delete: _delete
};

function getAll(params) {
  return (dispatch) => {
    dispatch(request());

    documentService.getAllPayments(params).then(
      (response) => dispatch(success(response)),
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка при получении списка документов на платежи",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request() {
    return { type: documentConstants.GETALL_REQUEST_PAYMENT };
  }
  function success(response) {
    return { type: documentConstants.GETALL_SUCCESS_PAYMENT, response };
  }
  function failure(error) {
    return { type: documentConstants.GETALL_FAILURE_PAYMENT, error };
  }
}

function update(id, params) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.updatePayment(id, params).then(
      (response) => {
        dispatch(success(response.result));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.UPDATE_REQUEST_PAYMENT, id };
  }
  function success(response) {
    return { type: documentConstants.UPDATE_SUCCESS_PAYMENT, response };
  }
  function failure(error) {
    return { type: documentConstants.UPDATE_FAILURE_PAYMENT, error };
  }
}

function archive(id, type) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.archiveDocument(id, type).then(
      (response) => {
        dispatch(success(id));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.ARCHIVE_REQUEST_PAYMENT, id };
  }
  function success(id) {
    return { type: documentConstants.ARCHIVE_SUCCESS_PAYMENT, id };
  }
  function failure(error) {
    return { type: documentConstants.ARCHIVE_FAILURE_PAYMENT, error };
  }
}

function changeViewStatus(id) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.changeView(id, OperationDocumentType.PAYMENT).then(
      (response) => {
        dispatch(success(response.result));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.VIEW_REQUEST_PAYMENT, id };
  }
  function success(response) {
    return { type: documentConstants.VIEW_SUCCESS_PAYMENT, response };
  }
  function failure(error) {
    return { type: documentConstants.VIEW_FAILURE_PAYMENT, error };
  }
}

function _delete(id, type) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.deleteDocument(id, type).then(
      (response) => {
        dispatch(success(id));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.DELETE_REQUEST_PAYMENT, id };
  }
  function success(id) {
    return { type: documentConstants.DELETE_SUCCESS_PAYMENT, id };
  }
  function failure(error) {
    return { type: documentConstants.DELETE_FAILURE_PAYMENT, error };
  }
}
